import React, { useEffect } from 'react';
import styled from 'styled-components';

import { News } from '../UI/News';
import useConfigs from '../../hooks/useConfigs';
import { useApi } from '../../hooks/useApi';

// ##### Estilos #####
const Container = styled.div`
  width: 95%;
  margin-left: auto;

  @media (max-width: 1023px) {
    width: 100%;
    margin-left: 0;
  }
`;

const SectionTitleNews = styled.div`
  h2 {
    text-align: center;
    margin-top: 100px;
    color: ${(props) => props.color};
    font-weight: 900;
    letter-spacing: 2px;
  }
`;

export const SectionNews = () => {
  const { fontSizeMultiplier, activeTheme } = useConfigs();
  const { noticias, getNoticias } = useApi();

  const h2color = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  useEffect(() => {
    getNoticias();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <SectionTitleNews
        className='section-title-news'
        color={h2color[activeTheme?.nombre]}
      >
        <h2 style={{ fontSize: 55 * fontSizeMultiplier }}>Noticias</h2>
      </SectionTitleNews>
      <div>
        <News data={noticias.data} isLoading={noticias.isLoading} />
      </div>
    </Container>
  );
};
